import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn,
} from "react-bootstrap-table";
import { Button, Classes, Dialog, FormGroup, H5, InputGroup, Popover, TextArea } from "@blueprintjs/core";
import { observable } from "mobx";
import { IItem, newIItem } from "../../model";
import { toast } from "react-toastify";
import { TribuNacionalStore } from "../../stores/legislacao/TribuNacionalStore";
import LoadingModal from "../loading/LoadingModal";

@observer
export default class TribuNacionalPage extends React.Component<{}, {}> {

  obs = observable({
    tributacao: newIItem() as IItem,
    open_create: false as boolean,
    open_edit: false as boolean
  })

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("Tributação Nacional");
  }

  async componentDidMount() {

    await TribuNacionalStore.handleLoadTribuNacional();

  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (código, descrição)"
      />
    );
  };

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  async handleDeleteTribu(id) {

    let res = await TribuNacionalStore.handleDeleteTribuNacional(id)

    if (res) {

      await TribuNacionalStore.handleLoadTribuNacional();

    }

  }

  handleEditTribu = (row) => {

    this.obs.tributacao = row;

    this.obs.open_edit = true

  };

  onClose() {

    this.obs.open_create = false
    this.obs.open_edit = false

    this.obs.tributacao = newIItem();

  }

  async handleCreate() {

    if (this.obs.tributacao.codigo == "") {
      toast.warning('Código obrgatório!', {});
      return
    }

    if (this.obs.tributacao.descricao == "") {
      toast.warning('Descrição obrgatória!', {});
      return
    }

    this.obs.open_create = false
    TribuNacionalStore.obs.loading = true


    let resp = await TribuNacionalStore.handleCreateTribuNacional(this.obs.tributacao)

    if (resp) {

      await TribuNacionalStore.handleLoadTribuNacional()

    }

    TribuNacionalStore.obs.loading = false
    this.obs.tributacao = newIItem();

  }

  async handleSave() {

    if (this.obs.tributacao.codigo == "") {
      toast.warning('Código obrgatório!', {});
      return
    }

    if (this.obs.tributacao.descricao == "") {
      toast.warning('Descrição obrgatória!', {});
      return
    }

    this.obs.open_edit = false
    TribuNacionalStore.obs.loading = true

    let resp = await TribuNacionalStore.handleUpdateTribuNacional(this.obs.tributacao)

    if (resp) {

      await TribuNacionalStore.handleLoadTribuNacional()

    }

    TribuNacionalStore.obs.loading = false
    this.obs.tributacao = newIItem();

  }

  render() {

    let user_admin = AppStore.obs1.usuario ? AppStore.obs1.usuario.admin : false

    let rows = TribuNacionalStore.obs.tribu_nacional?.map(emp => {
      return ({
        id: (emp._id || emp.id),
        codigo: emp.codigo,
        descricao: emp.descricao,
      });
    });

    const options = {
      searchField: this.createCustomSearchField,
    };

    const buttonFormatterDetalhes = (cell, row) => {
      return (
        <>
          <MDBBtn color="default" rounded size="sm">
            <img src="/images/edit.png" width={20} onClick={(e) => this.handleEditTribu(row)} />
          </MDBBtn>

          <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>

            <MDBBtn color="default" rounded size="sm">
              <img src="/images/bin.png" width={20} />
            </MDBBtn>

            <div>
              <H5>Confirmar exclusão?</H5>
              <p style={{ fontSize: 11 }}>Tem certeza de que deseja excluir esse item? Você não será capaz de recuperá-lo.</p>

              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15, }}>
                <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>Cancelar</Button>
                <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.handleDeleteTribu(row.id)}>Excluir</Button>
              </div>

            </div>
          </Popover>
        </>
      );
    }

    return (
      <>
        <MDBRow>
          {user_admin &&
            <MDBCol md="12">
              <MDBBtn className="btnDefault noFloat" onClick={() => this.obs.open_create = true} style={{ marginRight: 10 }}>
                Nova Tributação Nacional
              </MDBBtn>
            </MDBCol>
          }

          <MDBCol md="12">
            <BootstrapTable className="TableDefault" data={rows} options={options} hover search>
              <TableHeaderColumn dataField="codigo" isKey={true} width="10%">Código</TableHeaderColumn>
              <TableHeaderColumn dataField="descricao" width="90%">Descrição</TableHeaderColumn>
              {user_admin && <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="10%">Ações</TableHeaderColumn>}
            </BootstrapTable>
          </MDBCol>
        </MDBRow>

        <div style={{ marginBottom: 80 }} />

        <Dialog
          isOpen={this.obs.open_create}
          title="Criando Tributação Nacional"
          onClose={() => this.onClose()}
          style={{ width: 800, height: 600 }}
        >
          <div className={Classes.DIALOG_BODY}>

            <FormGroup
              label="Código"
              labelFor="codigo"
            >
              <InputGroup
                id="codigo"
                onChange={(e: any) => this.obs.tributacao.codigo = e.target.value}
              />
            </FormGroup>

            <FormGroup
              label="Descrição"
              labelFor="descricao"
            >
              <TextArea
                id="descricao"
                style={{ width: "100%" }}
                onChange={(e: any) => this.obs.tributacao.descricao = e.target.value}
              />
            </FormGroup>

          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.onClose()} />
              <Button text="Salvar" intent="primary" onClick={() => this.handleCreate()} />
            </div>
          </div>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_edit}
          title="Editando Tributação Nacional"
          onClose={() => this.onClose()}
          style={{ width: 800, height: 600 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <FormGroup
              label="Código"
              labelFor="codigo"
            >
              <InputGroup
                id="codigo"
                onChange={(e: any) => this.obs.tributacao.codigo = e.target.value}
                value={this.obs.tributacao.codigo}
              />
            </FormGroup>

            <FormGroup
              label="Descrição"
              labelFor="descricao"
            >
              <TextArea
                id="descricao"
                style={{ width: "100%" }}
                onChange={(e: any) => this.obs.tributacao.descricao = e.target.value}
                value={this.obs.tributacao.descricao}

              />
            </FormGroup>
          </div>

          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Cancelar" onClick={() => this.onClose()} />
              <Button text="Salvar" intent="primary" onClick={() => this.handleSave()} />
            </div>
          </div>

        </Dialog>

        <LoadingModal open={TribuNacionalStore.obs.loading} onClose={() => TribuNacionalStore.obs.loading = false} title={"Salvando"} />

      </>
    );
  }

}
